'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQCategoriesProps {
  categories: Array<{
    id: string;
    name: string;
    icon: string;
    count: number;
  }>;
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const FAQCategories = ({ categories, activeCategory, onCategoryChange }: FAQCategoriesProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="glassmorphic rounded-2xl p-6 mb-8">
        <h3 className="text-lg font-semibold text-foreground mb-4">Categorieën</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {categories.map((category) => (
            <div
              key={category.id}
              className="p-4 bg-muted rounded-xl text-center"
            >
              <div className="flex justify-center mb-2">
                <Icon name={category.icon as any} size={24} className="text-muted-foreground" />
              </div>
              <p className="text-sm font-medium text-foreground mb-1">{category.name}</p>
              <p className="text-xs text-muted-foreground">{category.count}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="glassmorphic rounded-2xl p-6 mb-8">
      <h3 className="text-lg font-semibold text-foreground mb-4">Categorieën</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`p-4 rounded-xl text-center transition-all duration-300 ${
              activeCategory === category.id
                ? 'bg-primary/20 border-2 border-primary glow-primary' :'bg-muted hover:bg-primary/10 border-2 border-transparent'
            }`}
          >
            <div className="flex justify-center mb-2">
              <Icon 
                name={category.icon as any} 
                size={24} 
                className={activeCategory === category.id ? 'text-primary' : 'text-muted-foreground'}
              />
            </div>
            <p className={`text-sm font-medium mb-1 ${
              activeCategory === category.id ? 'text-primary' : 'text-foreground'
            }`}>
              {category.name}
            </p>
            <p className="text-xs text-muted-foreground">{category.count}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FAQCategories;